import React, { useEffect, useState } from "react";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import useThemeColors from "../../vehicle/ThemeColors";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";
import { formatDate } from "../../../components/reusableComponent/DateFormat";
import ReactModal from "react-modal";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useGetAppointmentQuery } from "../../../Services/inventory/Inventory";
import { WORKSHOP_ID } from "../../../constants";
import { useNavigate } from "react-router-dom";
import CancelAppointment from "./CancelAppointment";
import RescheduleAppointment from "./RescheduleAppointment";
import Filteration from "./Filteration";

const Appointment = () => {
  const [appointmentsData, setAppointmentsData] = useState<any>([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
  const [openDetailsPage, setOpenDetailsPage] = useState(false);
  const [getCompleteRowDetails, setGetCompleteRowDetails] = useState<any>({});
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [storedAppointmentData, setStoredAppointmentData] = useState({});
  const [listingSTatus, setLiftingStatus] = useState("");

  const navigate = useNavigate();

  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);

  const {
    data: appointmentData,
    isLoading,
    refetch,
  } = useGetAppointmentQuery({ id: getWorkshopId, status: listingSTatus });

  const closeModal = () => {
    setOpenRescheduleModal(false);
    setOpenCancelModal(false);
  };

  useEffect(() => {
    if (appointmentData) {
      setAppointmentsData(appointmentData?.data);
    }
  }, [appointmentData]);

  useEffect(() => {
    if (openDetailsPage) {
      navigate(
        `/vehicle/appointment/${getCompleteRowDetails?.appointment_id}`,
        { state: getCompleteRowDetails }
      );
    }
  }, [getCompleteRowDetails, navigate, openDetailsPage]);

  const selectedRowClicked = (service) => {
    setOpenDetailsPage(true);
    setGetCompleteRowDetails(service);
  };

  const deleteService = (appointment) => {
    setStoredAppointmentData(appointment);
    setOpenCancelModal(true);
  };

  const rescheduleAppt = (appt) => {
    setStoredAppointmentData(appt);
    setOpenRescheduleModal(true);
  };

  const formatDate1 = (dateStr: string | undefined): string => {
    if (!dateStr) return 'N/A';
    
    const parts = dateStr.split('T');
    if (parts.length < 2) return 'Invalid date format';
  
    const [datePart, timePart] = parts;
    const dateParts = datePart?.split('-') || [];
    if (dateParts.length < 3) return 'Invalid date format';
  
    const [year, month, day] = dateParts;
    const timeComponents = (timePart?.split('.')[0] || '').split(':');
    if (timeComponents.length < 2) return 'Invalid time format';
  
    const [hours, minutes] = timeComponents;
    const hoursNum = parseInt(hours, 10) || 0;
  
    // Convert to 12-hour format
    let hour12 = hoursNum % 12;
    hour12 = hour12 === 0 ? 12 : hour12;
    const period = hoursNum >= 12 ? 'PM' : 'AM';
  
    return `${day}/${month}/${year}, ${hour12.toString().padStart(2, '0')}:${minutes} ${period}`;
  };

  return (
    <div className="vehicle-info-cont">
      <div className="workshops-container">
        <div className="workshops-header">
          <p
            style={{
              margin: "0",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontWeight: "200",
                fontSize: "20px",
                color: "#666666",
                fontFamily: "karbon",
              }}
            >
              Appointment
            </span>

            <p style={{ width: "40%", margin: "0" }}>
              <Filteration setLiftingStatus={setLiftingStatus} />
            </p>
          </p>
        </div>
        {isLoading || tableLoader ? (
          <LoadingSpinner />
        ) : (
          <div className="workshops-table-container">
            <table className="workshops-table">
              <thead>
                <tr style={{ background: "#F7D3C5" }}>
                  <th className="table-header">Appointment Id</th>
                  <th className="table-header">Workshop</th>
                  <th className="table-header">Service Name</th>
                  <th className="table-header">Sub Services</th>
                  <th className="table-header">Appointment Date</th>
                  <th className="table-header">Vehicle Number</th>
                  <th className="table-header">Status</th>
                  <th className="table-header">Action</th>
                </tr>
              </thead>
              <tbody>
                {appointmentsData?.map((workshop, index) => (
                  <tr
                    key={workshop.id}
                    className={index % 2 === 1 ? "row-alternate" : "row-normal"}
                  >
                    <td className="table-cell">
                      {workshop?.appointment_id}
                    </td>

                    <td className="table-cell">
                      {capitalizeFirstLetter(
                        workshop?.workshop_details?.workshopName
                      )}
                    </td>

                    {/* ✅ Service Names as Numeric List */}
                    <td className="table-cell">
                      <ol style={{ paddingLeft: "16px", margin: 0 }}>
                        {workshop?.booking_request?.service_details?.map(
                          (srv, idx) => (
                            <li key={idx}>{srv?.name}</li>
                          )
                        )}
                      </ol>
                    </td>

                    {/* ✅ Sub Service Names as Numeric List */}
                    <td
                      className="table-cell"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px",
                      }}
                    >
                      <ol style={{ paddingLeft: "16px", margin: 0 }}>
                        {workshop?.booking_request?.service_details?.flatMap(
                          (srv) =>
                            srv.sub_services?.map((sub, idx) => (
                              <li key={idx}>{sub?.name}</li>
                            ))
                        )}
                      </ol>
                    </td>

                    {/* ✅ Appointment Date formatted */}
                    <td className="table-cell">
                      {formatDate1(workshop?.appointment_date)}
                    </td>
                    <td className="table-cell">
                      {workshop?.vehicle_details?.vehicle_number}
                    </td>

                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.status)}
                    </td>



                    <td className="table-cell">
                      <button style={{ border: "none" }}>
                        <span
                          style={{
                            background: "#f15a22",
                            borderRadius: "20px",
                            padding: "5px",
                          }}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Preview"
                          onClick={() => selectedRowClicked(workshop)}
                        >
                          <i
                            className="bi bi-eye-fill"
                            style={{
                              fontSize: "17px",
                              color: "white",
                              padding: "10px",
                            }}
                          ></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Appointment;
